import React from "react";

const AdminLayout = ({ children }) => {
  return (
    <>
      <main>{children}</main>
    </>
  );
};

export default AdminLayout;
